import { Box, Typography, Tabs, Tab } from "@mui/material";
import { settings } from "app";

import { getTheme } from "customStyles/utils";
import { GRADES_TABLE_MIN_WIDTH, SEMESTER_GRID_GAP, semesterGridColumns } from "./semesterGrid";

import { SimpleShowLayout, ListContextProvider } from "react-admin";

// The selected tab is controlled by the caller so the elective / facultative tables, which render
// outside this component, can follow the same course.
// minColumnWidth: the width below which the two semester tables stop sitting side by side.
const TabsComponent = ({
  title,
  isMobile,
  array,
  responseObject,
  value,
  onChange,
  headerAction,
  minColumnWidth = GRADES_TABLE_MIN_WIDTH,
  children,
}) => {
  const theme = getTheme(settings.tenant);

  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  return (
    <>
      <Box sx={isMobile ? { ...settings.style.shadowBoxMobile } : { ...settings.style.shadowBox, mb: 12 }}>
        <Typography
          color="info"
          fontWeight={600}
          sx={{ ml: 2 }}
        >
          {title}
        </Typography>
        <SimpleShowLayout sx={{ mb: 4 }}>
          {/* Tabs header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            {/* scrollable: many courses no longer push the tab row wider than the box */}
            <Tabs
              onChange={handleChange}
              value={value}
              variant="scrollable"
              scrollButtons="auto"
              sx={{ minWidth: 0, maxWidth: "100%" }}
            >
              {array.map((item, idx) => (
                <Tab
                  key={idx}
                  label={`Курс ${idx + 1}`}
                  value={idx}
                  sx={{
                    px: "2.5rem",
                    borderRadius: "5px",
                    "&.Mui-selected": {
                      background: theme.palette.primary.main,
                      "&:hover": { background: theme.palette.primary.dark },
                      color: "#fff",
                    },
                  }}
                />
              ))}
            </Tabs>
            {headerAction}
          </Box>

          {/* Tabs content */}
          {array.map(
            (item, idx) =>
              value === idx && (
                <Box
                  key={idx}
                  sx={{
                    display: "grid",
                    // Two semesters side by side while both tables fit; otherwise the second one wraps
                    // onto a new row (see semesterGrid.js).
                    gridTemplateColumns: semesterGridColumns(isMobile, minColumnWidth),
                    gap: SEMESTER_GRID_GAP,
                    mt: 2,
                  }}
                >
                  {item.map(coursekey => {
                    const rows = responseObject[coursekey] || [];

                    const listContext = {
                      data: rows,
                      ids: rows.map(record => record.id),
                      total: rows.length,
                      loaded: true,
                    };

                    return (
                      <Box
                        key={coursekey}
                        // Fallback only: if even a full-width column is narrower than the table (very small
                        // screens), it scrolls inside the cell instead of widening the page.
                        sx={{ mb: 4, minWidth: 0, overflowX: "auto" }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ mb: 1 }}
                        >
                          {coursekey > 0 ? `${coursekey} Семестър` : null}
                        </Typography>
                        {rows.length > 0 ? (
                          <ListContextProvider value={listContext}>{children}</ListContextProvider>
                        ) : (
                          <Typography
                            variant="body1"
                            sx={{ mb: 1 }}
                            color="secondary"
                          >
                            {`Няма намерени данни за този семестър`}
                          </Typography>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              ),
          )}
        </SimpleShowLayout>
      </Box>
    </>
  );
};

export default TabsComponent;
